module.exports = __webpack_public_path__ + "static/media/analogicos-01.42f7a068.png";